import { ConditionTypeEnum } from '.'

export interface IMultiSelectCondition {
  /**
   * The values needed to evaluate the condition
   */
  comparison: {
    /**
     * The expected condition value
     *
     * e.g. 'Hazmat', 'Refrigerated', 'Temperature Controlled'
     */
    expectedValue?: string[]
    /**
     * The operator to evaluate the condition, e.g. (has any of, has all of, is exactly, has none of, is empty, is not empty)
     */
    operator: MultiSelectOperatorEnum
  }
  /**
   * The field name associated with the condition, e.g. ('equipmentTypes')
   */
  conditionName: string
  /**
   * The type of condition
   */
  conditionType: ConditionTypeEnum.MultiSelect
}
export enum MultiSelectOperatorEnum {
  HAS_ALL_OF = 'has all of',
  HAS_ANY_OF = 'has any of',
  HAS_NONE_OF = 'has none of',
  IS_EMPTY = 'is empty',
  IS_EXACTLY = 'is exactly',
  IS_NOT_EMPTY = 'is not empty'
}
